@if (!!cartContents) {
<div class="cart-popup">
  <div class="cart-content">
    <div class="navbarcart-header">
      <h6 class="navbarcart-title">{{ 'CART' | translate }}</h6>
      <div class="navbarcart-muted navbarcart-count">
        {{ 'CART_ARTICLE_SKU_TOTAL' | translate: { article: cartContents.rows.length, sku: cartContents.totalQuantity } }}
      </div>
    </div>

    <div class="navbarcart-total">
      <div class="navbarcart-muted">{{ 'TOTAL' | translate }}</div>
      <h5 class="navbarcart-total-value">
        <lib-price [price]="cartContents.totalValue" [currency]="cartContents.currency"></lib-price>
      </h5>
    </div>

    <button type="button" class="btn btn-primary w-100 navbarcart-btn-checkout" routerLink="/checkout" (click)="onClose()">
      {{ 'CHECKOUT' | translate }}
    </button>

    <div class="navbarcart-actions">
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="saveCart()">
        {{ 'SAVE_CART' | translate }}
      </button>
      @if (numberOfCustomers > 1) {
      <button type="button" class="btn btn-sm btn-outline-secondary" routerLink="/open-carts" (click)="onClose()">
        {{ 'OPEN_CARTS' | translate }}
      </button>
      }
    </div>

    <button type="button" class="btn btn-sm navbarcart-btn-clear" (click)="clearCart()">
      {{ 'CLEAR_CART' | translate }}
    </button>
  </div>
</div>
}
